module.exports = __webpack_public_path__ + "img/tank-base-shadow-3.17fd9d31.png";